module.exports = __webpack_public_path__ + "img/kamel_error.d8e528ce.png";